import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/logo.svg'
import Envelop from '../../assets/images/envelop.png'
import Lock from '../../assets/images/lock.png'
import { useAuth } from '../../Context/AuthContext';
import { Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import GoogleButton from 'react-google-button';


export default function Login() {
    const form = useForm();
    const { login, profile, refreshBeforeExpiration } = useAuth();
    const {
        register,
        handleSubmit,
        formState: { errors }
    } = form;
    const navigate = useNavigate();
    const buttonStyle = {
        backgroundColor: 'transparent',
        borderRadius: '30px',
        border: 'solid 3px #ffffff',
        width: '380px',
        fontSize: '1.25rem'
    };



    const onSubmit2 = async (data) => {
        const { email, password } = data;
        console.log('Data to send to signup:', { email, password });

        let result = await login({ email, password });
        const user = await profile();
        localStorage.removeItem('password');

        const refresh_token = localStorage.getItem('refreshToken');
        const expiration = localStorage.getItem('exDate');

        await refreshBeforeExpiration(refresh_token, expiration);

        console.log('User:', user);
        if (user && Array.isArray(user.sites)) {
            const userFavorites = user.sites.reduce((acc, id) => ({ ...acc, [id]: true }), {});
            localStorage.setItem('favorites', JSON.stringify(userFavorites));
        } else {
            console.error('User sites not found or not an array');
        }
        if (result) {
            navigate('/');
        }
    }
    const handleSignup = () => {
        navigate('/signup');

    };

    const handleGoogleLogin = () => {
        // Open Google authentication in a new window
        const authWindow = window.open('https://sydney-backend.vercel.app/auth/v1/google');

        // Listen for messages from the opened window
        window.addEventListener('message', (event) => {
            if (event.origin === 'https://sydney-backend.vercel.app') {
                // Handle the received message, e.g., extract tokens and redirect
                const { accessToken, refreshToken } = event.data;
                localStorage.setItem('access_token', accessToken);
                navigate("/home");

                // Close the new window
                authWindow.close();
            }
        });
    };





    return (
        <div className="Login-container">
            <div className="component-holder">
                <div className="filter">
                    <div className="header-holder">
                        <img className='logo' src={Logo} alt="logo" />
                        <p>Intelligent Heritage Explorer</p>
                    </div>
                    <div className='login-form'>
                        <form className="form-login-holder" onSubmit={handleSubmit(onSubmit2)} noValidate>
                            <div className='input-holder-email'>
                                <label>Email address</label>
                                <div className='input-with-icon' >
                                    <input
                                        type="email"
                                        placeholder="Alex@email.com"
                                        {...register('email', {
                                            required: true,
                                            pattern: /^[a-zA-Z0-9_.+-]+@(gmail\.com|yahoo\.com)$/
                                        })}
                                    />
                                    <img
                                        src={Envelop}
                                        alt="Envelope"
                                        className="icon"
                                    />
                                    {errors.email && errors.email.type === "required" && (
                                        <p className="errorMsg">Email is required.</p>
                                    )}
                                    {errors.email && errors.email.type === "pattern" && (
                                        <p className="errorMsg">Email is not valid.</p>
                                    )}

                                </div>

                            </div>
                            <div className='input-holder-password'>
                                <label>Password</label>
                                <div className='input-with-icon'>
                                    <input
                                        type="password"
                                        placeholder="Enter your password"
                                        {...register("password", {
                                            required: true,
                                        })}
                                    />
                                    <img
                                        src={Lock}
                                        alt="Lock"
                                        className="icon"
                                    />
                                    {errors.password && errors.password.type === "required" && (
                                        <p className="errorMsg">Password is required.</p>
                                    )}

                                </div>
                            </div>
                            <Link className='forget-password' to="/forgetpassword"> Forgot Password?</Link>

                            <div className='login-button-holder'>
                                <button className='login-button' type="submit">Login</button>
                                <div className='line-holder'>
                                    <hr className="horizontal-line" />
                                    <p className='or-text'>OR</p>
                                    <hr className="horizontal-line" />
                                </div>
                                <button className='signup-button-login-form' onClick={handleSignup}>Sign up</button>
                                <GoogleButton style={buttonStyle} className='google-btn' onClick={handleGoogleLogin} />


                            </div>

                        </form>


                    </div>

                </div>

            </div>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored" />
        </div>
    )
}